module.exports = __webpack_public_path__ + "static/media/危废处置_x264.a3b6599.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/危废处置_x264.mp4
// module id = Vk1h
// module chunks = 13